require('./lbaToast.scss');

const $inject = [];
const lbaToast = function () {
  return {
    restrict: 'A',
    scope:{},
    bindToController: true,
    controller: 'lbaToastCtrl',
    controllerAs: 'vm',
    template: require('./lbaToast.html')
  }
};

lbaToast.$inject = $inject;

export default lbaToast;



// WEBPACK FOOTER //
// ./src/components/lbaToast/lbaToastDir.js